import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { cellRenderer } from '../../../../SharedModules/utilities/utilities';

const textMatcher = ({ filterOption, value: val, filterText }) => {
  const value = Math.abs(val).toString();
  const valueWithDollar = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 || valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar.indexOf(filterText) === 0;
    case 'notEqual':
      return value != filterText.replace('$', '');
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      const index =
        value.lastIndexOf(filterText) || valueWithDollar.indexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

// For the proper sorting of quarter columns
const comparatorQtr = (a, b, nodeA, nodeB, isDescending) => {
  const splittedQtrA = a.split('Q');
  const splittedQtrB = b.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
export const ManufactureTableHead = [
   {
     headerName: 'Select',
     filter: false,
     checkboxSelection: true, 
     headerCheckboxSelection: false, 
     editable: false,
     suppressMenu: false,
     sortable: false,
     maxWidth: 135,
     cellStyle: { borderRightColor: Styles.BorderColor },
     pdfExportOptions: {
       skipColumn: true,
     },
 
   },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    sort: 'asc',
    maxWidth: Styles.Width_600,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_600,
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const TableHeaderForDetails = [
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    // resizable: false,
    minWidth: Styles.Width_125,
    comparator: comparatorQtr,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Status',
    field: 'invoiceStatusCd',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_130,
    cellRenderer: 'FullNameRender',
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Invoice Amount',
    field: 'totCurrQtrAmt',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_135,
    isTextColorRed: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },

    cellRenderer,
    printPrefixValue: '$',
    isAmount: true,
    alignment: 'right',
  },
  {
    headerName: 'Current Invoice Amount',
    field: 'sumOfAmount',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      textMatcher,
      refreshValuesOnOpen: true,
    },
    cellRenderer,
    printPrefixValue: '$',
    isAmount: true,
    alignment: 'right',
  },
  {
    headerName: 'Paid Amount',
    field: 'paidAmt',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_130,
    sortingOrder: ['desc', 'asc'],
    isTextColorRed: true,
    cellRenderer,
    printPrefixValue: '$',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
    isAmount: true,
    alignment: 'right',
  },
  {
    headerName: 'ROSI Postmarked Date',
    field: 'postmarkedDt',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    comparator: (a, b) => {
      return new Date(a) - new Date(b);
    },
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
  },
  {
    headerName: 'PQAS Payment Ind',
    field: 'ind',
    editable: false,
    showCheckboxIcon: true,
    sortable: false,
    hideFilterIcon: true,
    minWidth: Styles.Width_100,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: false,
    cellClass: 'pqas-payment-ind',
    cellRenderer: 'CheckBoxSelectedForRCellRender',
    alignment: 'center',
    checkbox: true,
  },
];
